import { Tab } from '@headlessui/react';

import SearchBarController from '~components/search/controller/SearchBarController';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import usePermissions from '~hooks/usePermissions';
import {
  selectAddonsIsMediaLibraryEnabled,
  selectConfigIsMediaLibraryMaintenance,
  selectSidebarIsCollapsed,
} from '~store/selectors';
import { isLessThanLarge } from '~utils/browser';

export const SearchHeader = () => {
  // Read redux state
  const isSidebarCollapsed = useAppSelector(selectSidebarIsCollapsed);
  const isMediaLibraryEnabled = useAppSelector(selectAddonsIsMediaLibraryEnabled);
  const isMediaLibraryMaintenance = useAppSelector(selectConfigIsMediaLibraryMaintenance);
  const { hasPassMaintenanceModePermission } = usePermissions();
  // labels
  const { labelSearchResults, labelMediaLibraryResults } = useLabels([
    'labelSearchResults',
    'labelMediaLibraryResults',
  ]);

  return (
    <header className="bg-white px-3">
      <div className="ml-search-result-list relative flex gap-3 py-3 mx-auto max-w-screen-xl w-full">
        {isSidebarCollapsed && isLessThanLarge() ? <div className="w-16" /> : null}
        <SearchBarController />
      </div>
      {isMediaLibraryEnabled && (!isMediaLibraryMaintenance || hasPassMaintenanceModePermission) ? (
        <div className="ml-search-result-list relative flex gap-3 py-3 mx-auto max-w-screen-xl w-full">
          <Tab.List className="border-t-0 border-l-0 border-r-0 border-b w-full border-solid border-darkgray flex gap-4">
            <Tab
              className={({ selected }) =>
                `appearance-none border-t-0 border-l-0 border-r-0 border-b-2 border-solid outline-none font-sans text-sm text-black bg-transparent m-0 px-0 pb-1 cursor-pointer ${
                  selected ? 'border-black font-semibold' : 'border-transparent'
                }`
              }
            >
              {labelSearchResults}
            </Tab>
            <Tab
              className={({ selected }) =>
                `appearance-none border-t-0 border-l-0 border-r-0 border-b-2 border-solid outline-none font-sans text-sm text-black bg-transparent m-0 px-0 pb-1 cursor-pointer ${
                  selected ? 'border-black font-semibold' : 'border-transparent'
                }`
              }
            >
              {labelMediaLibraryResults}
            </Tab>
          </Tab.List>
        </div>
      ) : null}
    </header>
  );
};
